import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Output,
	EventEmitter
} from "@angular/core";

import {
	LogCat,
	LogManager
} from "../../../log";

import {
	IListClickEvent
} from "./vertical.list.interface";


/*
* Selector: cp-vertical-list
* Change Detection: OnPush
* View Encapsulation: Emulated
*
* Inputs:
* items: Array<any>				// Mandatory Items Array, array can be simple array such as [2, 32, 'item#1', 'item#X', ...]
* 								// or an array of objects [{...}, {...}, {...}, ...]
* displayField?: string			// Optional, needed if items is an array of objects
* selectedIndex?: number		// Optional, used to pass the selected index for highlighting the item in the list
*
* Outputs:
* itemClick?: EventEmitter<any>	// Optional, for emitting event: {event: DOMEvent, selectedIndex: number, selectedItem: any}
* */

@Component({
	selector: 'cp-vertical-list',
	templateUrl: './vertical.list.html',
	styleUrls: ['./vertical.list.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalListComponent {

	@Input() items: Array<any>;
	@Input() displayField: string = null;
	@Input() selectedIndex: number = 0;

	@Output() itemClick: EventEmitter<IListClickEvent> = new EventEmitter<IListClickEvent>(false);

	/*
	* List Item Click Handler
	* */
	public itemClickHandler($event, selectedIndex, selectedItem) {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"VerticalListComponent.itemClickHandler");
		let outputEvent: IListClickEvent = { event: $event, selectedIndex: selectedIndex, selectedItem: selectedItem };
		this.itemClick.emit(outputEvent);
	}

	/*
	* List Track By for ngFor directive in template
	* */
	public trackByIndex(index: number, item: any) {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"VerticalListComponent.trackByIndex");
		return index;
	}
}

